<template>
  <div class="with-side-panel">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <div class="d-flex justify-content-between">
            <h6 class="element-header">
              Externe Coachabrechnung
            </h6>
          </div>

          <div class="element-box overflow-hidden">
            <div class="row">
              <!-- 1. Einzelcoaching -->
              <CoachingButton
                  :enabled="true"
                  route-name="coachBillingPrivateCoachingPreviewList"
                  coaching-type="private"
                  label="Einzelcoaching"/>

              <!-- 2. Gruppenmaßnahmen -->
              <CoachingButton
                  :enabled="true"
                  route-name="coachBillingGroupCoachingPreviewList"
                  coaching-type="group"
                  label="Gruppenmaßnahmen"/>

              <!-- 3. Betreutes Wohnen -->
              <CoachingButton
                  :enabled="true"
                  route-name="coachBillingAssistedLivingCoachingPreviewList"
                  coaching-type="assistedLiving"
                  label="Betreutes Wohnen"/>

              <!-- 4. DRV Fallmanagement -->
              <CoachingButton
                  :enabled="true"
                  route-name="coachBillingCaseManagementCoachingPreviewList"
                  coaching-type="caseManagement"
                  label="DRV Fallmanagement"/>
            </div>
          </div>
        </div>
      </div>
      <Sidebar></Sidebar>
    </div>
  </div>
</template>

<script setup>
import Sidebar from '@/components/FormSidebar.vue';
import CoachingButton from "@/components/button/CoachingButton.vue";
</script>

<style scoped>

</style>